<template>
  <v-content>
    <d-header></d-header>
    <router-view />
  </v-content>
</template>

<script>
import { mapState } from 'vuex'
import DHeader from '@/components/common/Header'

export default {
  computed: {
    ...mapState('auth', ['profile'])
  },
  components: {
    DHeader
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/index.vue